import React, { useEffect, useState, useRef, useCallback } from 'react';
import cn from 'classnames/bind';
import { RadioGroup } from '@consta/uikit/RadioGroup';
import { Text } from '@consta/uikit/Text';
import { IconQuestion } from '@consta/uikit/IconQuestion';
import { TextField } from '@consta/uikit/TextField';
import { Combobox } from '@consta/uikit/Combobox';

// Styles
import styles from './styles.styl';
import {
  TestFormName,
  TestFormNameHello,
  TestFormNameTags,
  TestFormNameThank,
  TestFormTitle,
  TestFormTooltipTest,
  TestFormTooltipText,
  TestFormTooltipTextCalendars,
  TestFormTooltipTextScoreAnswers,
  TestFormTooltipTextTags,
  TestFormTooltipTextTrueAnswers,
  TestFormTypeCounterFullText,
  TestFormTypeCounterPartialText,
} from 'src/config/config';
import { withTooltip } from '@consta/uikit/withTooltip';
import { Theme } from '@consta/uikit/Theme';
import { myPreset } from 'src/utils/myPreset';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { Action } from 'redux';
import {
  setTestDataFinal,
  setTestDataName,
  setTestDataTags,
  setTestDataType,
  setTestDataWelcome,
  setTestScore,
  setShowPoints,
  setShowAnswers,
  setCronStarted,
  setCronFinished,
  setTypeCounter,
} from 'src/redux/features/surveys/testData/actions';
import {
  FinalItem,
  TagsType,
  TestState,
  WelcomeItem,
} from 'src/redux/features/surveys/testData/types';
import {
  allTagLoadedSelector,
  allTagSelector,
  shouldLoadAllListCompanySelector,
} from 'src/redux/features/surveys/allTag/selectors';
import { loadListTag } from 'src/redux/features/surveys/allTag/actions';
import { ISurvey, ITag } from 'src/redux/features/surveys/allSurvey/types';
import { Loader } from '@consta/uikit/Loader';
import { initSurveySelector } from 'src/redux/selectors';
import { InitSurveyInterface } from 'src/utils/types';
import { userInitLoadedSelector } from 'src/redux/features/userInit/selectors';
import {
  SurveyStatusEnum,
  SurveyTypeEnum,
  TitleTestEnum,
} from 'src/utils/enum';
import { AllListQuestionDataEnt } from 'src/redux/features/questions/allListQuestions/types';
import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';
import { Switch } from '@consta/uikit/Switch';
import { DateTime } from '@consta/uikit/DateTimeCanary';
import { Button } from '@consta/uikit/Button';
import { IconCalendar } from '@consta/uikit/IconCalendar';
import { Select } from '@consta/uikit/Select';
import { compareDay } from 'src/utils';

const cx = cn.bind(styles);

export interface TestFormProps {
  className?: string;
  setTestDataName: (name: string) => void;
  setTestDataType: (type: number) => void;
  setTestDataWelcome: (data: WelcomeItem) => void;
  setTestDataFinal: (data: FinalItem) => void;
  setTestDataTags: (tag: TagsType[]) => void;
  setTestScore: (data: number) => void;
  setSave: (data: boolean) => void;
  testData: TestState;
  loadTags: () => void;
  allTagLoaded: boolean;
  allTagShoald: boolean;
  allTag: ITag[];
  initSurvey: InitSurveyInterface[];
  userInitLoaded: boolean;
  allListQuestion: AllListQuestionDataEnt[];
  titleCreateTest: TitleCreateTestType;
  oneSurvey: ISurvey;
  setShowAnswers: (value: boolean) => void;
  setShowPoints: (value: boolean) => void;
  setStoreCronStarted: (date: Date | null) => void;
  setStoreCronFinished: (date: Date | null) => void;
  setTypeCounter: (type: number) => void;
}

const TestForm: React.FC<TestFormProps> = ({
  className,
  setTestDataName,
  setTestDataType,
  setTestDataWelcome,
  setTestDataFinal,
  setTestDataTags,
  testData,
  setSave,
  loadTags,
  allTagShoald,
  allTagLoaded,
  allTag,
  initSurvey,
  userInitLoaded,
  setTestScore,
  allListQuestion,
  titleCreateTest,
  oneSurvey,
  setShowAnswers,
  setShowPoints,
  setStoreCronStarted,
  setStoreCronFinished,
  setTypeCounter,
}) => {
  const TextWithTooltip = withTooltip()(Text);

  useEffect(() => {
    allTagShoald && loadTags();
  }, [allTagShoald, loadTags]);

  const [activeRadio, setActiveRadio] = useState<InitSurveyInterface | null>(
    null,
  );
  const [name, setName] = useState('');

  const [addTag, setAddTag] = useState(null);
  const [nameHello, setNameHello] = useState('');
  const [areaHellow, setAreaHellow] = useState('');

  const [nameThank, setNameThank] = useState('');
  const [areaThank, setAreaThank] = useState('');

  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);

  const [isShowAnswers, setIsShowAnswers] = useState(false);
  const [isShowPoints, setIsShowPoints] = useState(false);

  const [dateStart, setDateStart] = useState(null);
  const [isDateStart, setIsDateStart] = useState(false);
  const dateStartRef = useRef(null);

  const [dateFinish, setDateFinish] = useState(null);
  const [isDateFinish, setIsDateFinish] = useState(false);
  const dateFinishRef = useRef(null);

  const [typeOfCounter, setTypeOfCounter] = useState(0);

  useEffect(() => {
    userInitLoaded && setActiveRadio(initSurvey[testData.type]);
  }, [initSurvey, testData, userInitLoaded]);

  useEffect(() => {
    setName(testData.name);
    setAddTag(testData.tags?.length === 0 ? null : testData.tags);
    setNameHello(testData.welcome_page_header);
    setAreaHellow(testData.welcome_page_description);
    setNameThank(testData.final_page_header);
    setAreaThank(testData.final_page_description);
    setScore(testData?.passing_score || 0);
    setIsShowAnswers(testData.is_show_answers);
    setIsShowPoints(testData.is_show_points);
    setDateStart(
      testData.cron_started_at ? new Date(testData.cron_started_at) : null,
    );
    setDateFinish(
      testData.cron_finished_at ? new Date(testData.cron_finished_at) : null,
    );
    setTypeOfCounter(testData.type_counter);
  }, [testData]);

  useEffect(() => {
    if (SurveyTypeEnum.TEST === activeRadio?.id) {
      const sumPoints = allListQuestion.reduce(
        (partial_sum, a) => partial_sum + a.points,
        0,
      );
      setTotalScore(sumPoints);
    }
  }, [activeRadio, allListQuestion]);

  useEffect(() => {
    const clickOutside = (e: MouseEvent) => {
      dateStartRef?.current &&
        !dateStartRef.current.contains(e.target) &&
        setIsDateStart(false);

      dateFinishRef?.current &&
        !dateFinishRef.current.contains(e.target) &&
        setIsDateFinish(false);
    };
    document.addEventListener('click', clickOutside);
    return () => document.removeEventListener('click', clickOutside);
  }, []);

  const handleChangeDateStart = useCallback(
    (value) => {
      setDateStart(value);
      setStoreCronStarted(value);

      setSave(true);
      if (
        value &&
        compareDay(value, new Date()) &&
        (!dateStart || value <= new Date())
      ) {
        const currentTime = new Date();
        currentTime.setMinutes(currentTime.getMinutes() + 5);
        setDateStart(currentTime);
        setStoreCronStarted(currentTime);
      }
    },
    [dateStart, setSave, setStoreCronStarted],
  );

  const handleChangeDateFinished = useCallback(
    (value) => {
      setDateFinish(value);
      setStoreCronFinished(value);
      setSave(true);
      if (
        value &&
        compareDay(value, new Date()) &&
        (!dateFinish || value <= new Date())
      ) {
        const currentTime = new Date();
        currentTime.setMinutes(currentTime.getMinutes() + 5);
        setDateFinish(currentTime);
        setStoreCronFinished(currentTime);
      }
    },
    [dateFinish, setSave, setStoreCronFinished],
  );

  const getFullTime = (date: Date) => {
    if (date) {
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
  };

  const addFiveMinutes = () => {
    const CurrentTime = new Date();
    CurrentTime.setMinutes(CurrentTime.getMinutes() + 5);
    return CurrentTime;
  };

  const addFinishMinutes = () => {
    const CurrentTime = new Date();
    CurrentTime.setMinutes(CurrentTime.getMinutes() + 5);
    return CurrentTime;
  };

  const itemsTypeOfCounter: { label: string; id: number }[] = [
    { label: TestFormTypeCounterFullText, id: 0 },
    { label: TestFormTypeCounterPartialText, id: 1 },
  ];

  if (!allTagLoaded) return <Loader />;
  return (
    <div className={cx('TestForm', className)}>
      <div className={cx('TestForm__container')}>
        <div className={cx('TestForm__title')}>
          <Text weight="semibold" size="m">
            {TestFormTitle}
          </Text>
          <Theme preset={myPreset}>
            <TextWithTooltip
              lineHeight="s"
              size="s"
              tooltipProps={{
                content: (
                  <div>
                    <Text
                      size="xs"
                      lineHeight="xs"
                      className={cx('TestForm__colorTooltip')}
                    >
                      {TestFormTooltipText}
                    </Text>
                  </div>
                ),
                className: cx('TestForm__colorTooltip'),
              }}
            >
              <IconQuestion className={cx('TestForm__iconQuestion')} />
            </TextWithTooltip>
          </Theme>
        </div>
        <RadioGroup
          value={activeRadio}
          items={initSurvey}
          getLabel={(item) => item.name}
          onChange={({ value }) => {
            setActiveRadio(value);
            setTestDataType(value.id);
            setSave(true);
          }}
          align="center"
          size="l"
          disabled={
            titleCreateTest.id === TitleTestEnum.Edit &&
            oneSurvey.status !== SurveyStatusEnum.DRAFT
          }
          className={cx('TestForm__radio')}
        />
        {SurveyTypeEnum.TEST === activeRadio?.id && (
          <div className={cx('TestForm__testScore')}>
            <div className={cx('TestForm__rowTest')}>
              <Text
                className={cx('TestForm__testTitle')}
                view="secondary"
                size="m"
              >
                {'Проходной балл'}
              </Text>
              <Theme preset={myPreset}>
                <TextWithTooltip
                  lineHeight="s"
                  size="s"
                  tooltipProps={{
                    content: (
                      <div>
                        <Text
                          size="xs"
                          lineHeight="xs"
                          className={cx('TestForm__colorTooltip')}
                        >
                          {TestFormTooltipTest}
                        </Text>
                      </div>
                    ),
                    className: cx('TestForm__colorTooltip'),
                  }}
                >
                  <IconQuestion className={cx('TestForm__iconQuestion')} />
                </TextWithTooltip>
              </Theme>
            </div>
            <div className={cx('TestForm__fieldScore')}>
              <TextField
                className={cx('TestForm__textFieldScore')}
                onChange={({ value }) => {
                  (!isNaN(Number(value)) || value === null) && setScore(+value);
                  setTestScore(+value);
                  setSave(true);
                }}
                value={String(score)}
                size="m"
                disabled={
                  titleCreateTest.id === TitleTestEnum.Edit &&
                  oneSurvey.status !== SurveyStatusEnum.DRAFT
                }
              />
              <Text view="secondary" size="m">
                {`Всего баллов: ${totalScore}`}
              </Text>
            </div>
          </div>
        )}
        {SurveyTypeEnum.TEST === activeRadio?.id && (
          <>
            <div className={cx('TestForm__switch')}>
              <Switch
                label="Отображать правильный ответ"
                checked={isShowAnswers}
                onChange={() => {
                  setIsShowAnswers((prev) => !prev);
                  setShowAnswers(!isShowAnswers);
                  setSave(true);
                }}
              />
              <Theme preset={myPreset}>
                <TextWithTooltip
                  lineHeight="s"
                  size="s"
                  tooltipProps={{
                    content: (
                      <div>
                        <Text
                          size="xs"
                          lineHeight="xs"
                          className={cx('TestForm__colorTooltip')}
                        >
                          {TestFormTooltipTextTrueAnswers}
                        </Text>
                      </div>
                    ),
                    className: cx('TestForm__colorTooltip'),
                  }}
                >
                  <IconQuestion className={cx('TestForm__iconQuestion')} />
                </TextWithTooltip>
              </Theme>
            </div>
            <div className={cx('TestForm__switch')}>
              <Switch
                label="Отображать количество баллов за ответ"
                checked={isShowPoints}
                onChange={() => {
                  setIsShowPoints((prev) => !prev);
                  setShowPoints(!isShowPoints);
                  setSave(true);
                }}
              />
              <Theme preset={myPreset}>
                <TextWithTooltip
                  lineHeight="s"
                  size="s"
                  tooltipProps={{
                    content: (
                      <div>
                        <Text
                          size="xs"
                          lineHeight="xs"
                          className={cx('TestForm__colorTooltip')}
                        >
                          {TestFormTooltipTextScoreAnswers}
                        </Text>
                      </div>
                    ),
                    className: cx('TestForm__colorTooltip'),
                  }}
                >
                  <IconQuestion className={cx('TestForm__iconQuestion')} />
                </TextWithTooltip>
              </Theme>
            </div>
          </>
        )}
        <div className={cx('TestForm__calendarsContainer')}>
          <div
            ref={dateStartRef}
            className={cx(
              'TestForm__fieldAndCalendarContainer',
              'TestForm__startCalendar',
            )}
          >
            <div
              className={cx('TestForm__calendarFieldContainer')}
              onClick={() => setIsDateStart(true)}
            >
              <TextField
                type="text"
                placeholder="ДД.ММ.ГГГГ ЧЧ:ММ:СС"
                value={getFullTime(dateStart)}
                className={cx('TestForm__calendarField')}
                label="Дата публикации"
              />
              <IconCalendar
                className={cx('TestForm__iconCalendar')}
                size="s"
                view="ghost"
              />
            </div>
            {isDateStart && (
              <div className={cx('TestForm__calendarContainer')}>
                <DateTime
                  type="date-time"
                  value={dateStart}
                  onChange={({ value }) => {
                    handleChangeDateStart(value);
                  }}
                  minDate={addFiveMinutes()}
                />
                <div className={cx('TestForm__calendarActions')}>
                  <Button
                    view="ghost"
                    label="Очистить"
                    size="s"
                    onClick={() => {
                      setDateStart(null);
                      setStoreCronStarted(null);
                      setSave(true);
                    }}
                  />
                  <Button
                    view="primary"
                    label="Выбрать"
                    size="s"
                    onClick={() => setIsDateStart(false)}
                  />
                </div>
              </div>
            )}
          </div>
          <div
            ref={dateFinishRef}
            className={cx('TestForm__fieldAndCalendarContainer')}
          >
            <div
              className={cx('TestForm__calendarFieldContainer')}
              onClick={() => setIsDateFinish(true)}
            >
              <TextField
                type="text"
                placeholder="ДД.ММ.ГГГГ ЧЧ:ММ:СС"
                value={getFullTime(dateFinish)}
                className={cx('TestForm__calendarField')}
                label="Дата завершения"
              />
              <IconCalendar
                className={cx('TestForm__iconCalendar')}
                size="s"
                view="ghost"
              />
            </div>
            {isDateFinish && (
              <div className={cx('TestForm__calendarContainer')}>
                <DateTime
                  type="date-time"
                  value={dateFinish}
                  onChange={({ value }) => {
                    handleChangeDateFinished(value);
                  }}
                  minDate={addFinishMinutes()}
                />
                <div className={cx('TestForm__calendarActions')}>
                  <Button
                    view="ghost"
                    label="Очистить"
                    size="s"
                    onClick={() => {
                      setDateFinish(null);
                      setStoreCronFinished(null);
                      setSave(true);
                    }}
                  />
                  <Button
                    view="primary"
                    label="Выбрать"
                    size="s"
                    onClick={() => setIsDateFinish(false)}
                  />
                </div>
              </div>
            )}
          </div>
          <Theme preset={myPreset}>
            <TextWithTooltip
              lineHeight="s"
              size="s"
              tooltipProps={{
                content: (
                  <div>
                    <Text
                      size="xs"
                      lineHeight="xs"
                      className={cx('TestForm__colorTooltip')}
                    >
                      {TestFormTooltipTextCalendars}
                    </Text>
                  </div>
                ),
                className: cx('TestForm__calendarTooltip'),
              }}
            >
              <IconQuestion className={cx('TestForm__iconQuestionCalendar')} />
            </TextWithTooltip>
          </Theme>
        </div>
        {SurveyTypeEnum.TEST === activeRadio?.id && (
          <Select
            disabled={oneSurvey.status !== SurveyStatusEnum.DRAFT}
            className={cx('TestForm__textField')}
            items={itemsTypeOfCounter}
            label="Вариант подсчёта баллов"
            value={{
              label: itemsTypeOfCounter[typeOfCounter].label,
              id: typeOfCounter,
            }}
            onChange={({ value }) => {
              setTypeOfCounter(value.id);
              setTypeCounter(value.id);
              setSave(true);
            }}
          />
        )}
        <Text className={cx('TestForm__directTitle')} view="secondary" size="m">
          {TestFormName}
        </Text>
        <TextField
          className={cx('TestForm__textField')}
          onChange={({ value }) => {
            setName(value);
            setTestDataName(value);
            setSave(true);
          }}
          value={name}
          size="m"
          placeholder="Название"
        />
        <div className={cx('TestForm__tagsTitleContainer')}>
          <Text
            className={cx('TestForm__directTitle')}
            view="secondary"
            size="m"
          >
            {TestFormNameTags}
          </Text>
          <Theme preset={myPreset}>
            <TextWithTooltip
              lineHeight="s"
              size="s"
              tooltipProps={{
                content: (
                  <div>
                    <Text
                      size="xs"
                      lineHeight="xs"
                      className={cx('TestForm__colorTooltip')}
                    >
                      {TestFormTooltipTextTags}
                    </Text>
                  </div>
                ),
                className: cx('TestForm__colorTooltip'),
              }}
            >
              <IconQuestion className={cx('TestForm__iconQuestion')} />
            </TextWithTooltip>
          </Theme>
        </div>
        <Combobox
          className={cx('TestForm__textField')}
          placeholder="Выберите или введите"
          items={allTag}
          searchFunction={() => false}
          size="m"
          multiple
          value={addTag}
          getItemLabel={(item) => item.name}
          onChange={({ value }) => {
            if (!(value?.length > 3)) {
              setAddTag(value);
              setTestDataTags(value || null);
              setSave(true);
            }
          }}
          onCreate={({ label }) => {
            let data;
            if (!(addTag?.length > 2)) {
              addTag
                ? (data = [
                    {
                      name: label,
                      id: Math.random() * 100,
                    },
                    ...addTag,
                  ])
                : (data = [
                    {
                      name: label,
                      id: Math.random() * 100,
                    },
                  ]);
              setAddTag(data);
              setTestDataTags(data);
              setSave(true);
            }
          }}
        />
        <Text className={cx('TestForm__helloTitle')} weight="semibold" size="m">
          {TestFormNameHello}
        </Text>
        <TextField
          className={cx('TestForm__textFieldHello')}
          onChange={({ value }) => {
            setNameHello(value);
            setTestDataWelcome({
              welcomeTitle: value,
              welcomeDescription: areaHellow,
            });
            setSave(true);
          }}
          value={nameHello}
          size="m"
          type="textarea"
          placeholder="Заголовок"
          minRows={1}
          maxRows={4.5}
        />
        <TextField
          className={cx('TestForm__textField')}
          onChange={({ value }) => {
            setAreaHellow(value);
            setTestDataWelcome({
              welcomeTitle: nameHello,
              welcomeDescription: value,
            });
            setSave(true);
          }}
          value={areaHellow}
          type="textarea"
          size="m"
          placeholder="Описание"
          rows={4.5}
        />
        <Text className={cx('TestForm__helloTitle')} weight="semibold" size="m">
          {TestFormNameThank}
        </Text>
        <TextField
          className={cx('TestForm__textFieldHello')}
          onChange={({ value }) => {
            setNameThank(value);
            setTestDataFinal({
              finalTitle: value,
              finalDescription: areaThank,
            });
            setSave(true);
          }}
          value={nameThank}
          size="m"
          placeholder="Заголовок"
          type="textarea"
          minRows={1}
          maxRows={4.5}
        />
        <TextField
          className={cx('TestForm__textFieldThank')}
          onChange={({ value }) => {
            setAreaThank(value);
            setTestDataFinal({
              finalTitle: nameThank,
              finalDescription: value,
            });
            setSave(true);
          }}
          value={areaThank}
          type="textarea"
          size="m"
          placeholder="Описание"
          rows={4.5}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: State, props: any) => ({
  allTagLoaded: allTagLoadedSelector(state, props),
  allTagShoald: shouldLoadAllListCompanySelector(state),
  allTag: allTagSelector(state),
  initSurvey: initSurveySelector(state),
  userInitLoaded: userInitLoadedSelector(state, props),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<State, void, Action>) => ({
  setTestDataName: (name: string) => dispatch(setTestDataName(name)),
  setTestDataType: (type: number) => dispatch(setTestDataType(type)),
  setTestDataWelcome: (data: WelcomeItem) => dispatch(setTestDataWelcome(data)),
  setTestDataFinal: (data: FinalItem) => dispatch(setTestDataFinal(data)),
  setTestDataTags: (tag: TagsType[]) => dispatch(setTestDataTags(tag)),
  setTestScore: (data: number) => dispatch(setTestScore(data)),
  loadTags: () => dispatch(loadListTag()),
  setShowAnswers: (value: boolean) => dispatch(setShowAnswers(value)),
  setShowPoints: (value: boolean) => dispatch(setShowPoints(value)),
  setStoreCronStarted: (date: Date | null) => dispatch(setCronStarted(date)),
  setStoreCronFinished: (date: Date | null) => dispatch(setCronFinished(date)),
  setTypeCounter: (type: number) => dispatch(setTypeCounter(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TestForm);
